<div style="background: #F5F5F5; padding: 16px;" *ngIf="client">

  <!-- ClickUp 868jtq1h0: legacy "Client Info / Tax Plans / Tax Projections"
       tabbed layout removed entirely. Tax Projections is now reached only
       via the post-login choose-platform card (login.component.ts +
       /choose-platform). The non-tabbed view below is the canonical
       client-detail view in V1; the `*ngIf="!projectionsAccess"` gate
       is dropped so it always renders. -->
  <ng-container>
    <div class="row page-title-bar" style="margin-bottom: 16px;">
      <div class="medium-12 title">Client Info</div>
    </div>
    <div class="row" style="background: #FFFFFF;">
      <div class="column medium-9" style="font-size: 18px;font-weight: 500;color: #333333;padding: 15px;">
        {{client.firstName}} {{client.lastName}}
      </div>
      <div class="column medium-3">
        <div class="compose-post float-right" style="margin-top: 10px;padding: 0 20px !important;"(click)="changeClientStatus()">
          <span>Inactive</span>
        </div>
        <div class="float-right pointer" style="margin: 10px 10px;color: #1570EF;display: inline-flex;position: relative;top: 5px;" (click)="editClientInfo()">
          <i style="font-size: 18px;position: relative;top: 2px;" class="material-icons">mode_edit</i>Edit
        </div>
      </div>
      <div class="column medium-12">
        <hr style="margin: 0"/>
      </div>
      <div class="column medium-12">
        <div class="row user-profile-css" style="margin-top: 15px;">
          <div class="column medium-4">
            <div class="row">
              <div class="medium-12 row-padding-bottom">
                <div class="row">
                  <div class="small-12 medium-3">
                    <span class="profile-title">Status:</span>
                  </div>
                  <div class="small-12 medium-9">
                    <label>{{client.status || ''}}</label>
                  </div>
                </div>
              </div>
              <div class="medium-12 row-padding-bottom">
                <div class="row">
                  <div class="small-12 medium-3">
                    <span class="profile-title">Email:</span>
                  </div>
                  <div class="small-12 medium-9">
                    <label *ngIf="!protectedView">{{client.email}}</label>
                  </div>
                </div>
              </div>
              <div class="medium-12 row-padding-bottom">
                <div class="row">
                  <div class="small-12 medium-3">
                    <span class="profile-title">Phone:</span>
                  </div>
                  <div class="small-12 medium-9">
                    <label>{{client.phoneNumber}}</label>
                  </div>
                </div>
              </div>
              <div class="medium-12 row-padding-bottom">
                <div class="row">
                  <div class="small-12 medium-3">
                    <span class="profile-title">Labels:</span>
                  </div>
                  <div class="small-12 medium-9 tax-planning-client">
                    <div *ngFor="let item of client.labels">
                        <span class="client-label">
                          <span>{{item.label}}</span>
                        </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="medium-12 row-padding-bottom" *ngIf="clientPortalAccess">
                <div class="row">
                  <div class="small-12 medium-3">
                    <span class="profile-title">Portal:</span>
                  </div>
                  <div class="small-12 medium-9">
                    <span class="enabled-badge" *ngIf="client.enableClientPortal"><img src="./images/tpiq-icons/SVG/dot.svg"> Enabled</span>
                    <span class="not-enabled-badge" *ngIf="!client.enableClientPortal"> Not Enabled</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column medium-4">
            <div class="row row-padding-bottom">
              <div class="medium-12">
                <span class="profile-title">Related Parties</span>
              </div>
              <div class="medium-12" *ngIf="clientsList && clientsList.length > 0">
                <div class="row" *ngFor="let item of clientsList | slice:0:5;" style="margin-bottom: 3px;">
                  <div class="small-12 medium-6 tax-planning-client">
                    <span class="client-label">{{item.name}} ({{item.type}})</span>
                  </div>
                </div>
                <div class="ps-3" *ngIf="clientsList.length > 5">
                  <label>... And more</label>
                </div>
              </div>
              <div class="medium-12 mt-2">
                <span class="profile-title">Questionnaire Status</span>
              </div>
              <div class="medium-12">
                <div class="row" *ngIf="organizerAccess && !this.questionnaire.resend">
                  <div class="small-12 medium-4">
                    <span class="questionnaire-status-not-sent">Not Sent</span>
                  </div>
                  <div class="small-12 medium-6">
                    <span class="questionnaire-label pointer" (click)="addQuestionnaire()"><img src="./images/tpiq-icons/SVG/send_icon.svg"> Send Questionnaire</span>
                  </div>
                </div>
                <div class="row" *ngIf="organizerAccess && this.questionnaire.resend && (!questionnaireTrackStatus || questionnaireTrackStatus === 'Sent')">
                  <div class="small-12 medium-4">
                    <span class="questionnaire-status-sent"><img src="./images/tpiq-icons/SVG/sent_icon.svg"> Sent</span>
                  </div>
                  <div class="small-12 medium-6">
                    <span class="questionnaire-label pointer" (click)="addQuestionnaire()"><img src="./images/tpiq-icons/SVG/resend_icon.svg"> Resend Questionnaire</span>
                  </div>
                </div>
                <div class="row" *ngIf="organizerAccess && this.questionnaire.resend && questionnaireTrackStatus && questionnaireTrackStatus !== 'Sent'">
                  <div class="small-12 medium-4">
                    <span class="questionnaire-status-sent"><img src="./images/tpiq-icons/SVG/sent_icon.svg"> {{questionnaireTrackStatus}}</span>
                  </div>
                  <div class="small-12 medium-6">
                    <span class="questionnaire-label pointer" *ngIf="questionnaireRow" (click)="viewAnswers()">View Answers</span>
                    <span class="questionnaire-label pointer ps-3" (click)="addQuestionnaire()"><img src="./images/tpiq-icons/SVG/resend_icon.svg"> Resend Questionnaire</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column medium-4">
            <div class="row row-padding-bottom">
              <div class="medium-12">
                <span class="profile-title">Third Parties</span>
              </div>
              <div class="medium-12" *ngIf="thirdPartiesList && thirdPartiesList.length >0">
                <div class="row" *ngFor="let item of thirdPartiesList" style="margin-bottom: 3px;">
                  <div class="small-12 medium-6 tax-planning-client">
                    <span class="client-label">{{item.name}} ({{item.type}})</span>
                  </div>
                </div>
              </div>
              <div class="medium-12" *ngIf="thirdPartiesList && thirdPartiesList.length == 0">
                <label>No third parties available.</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tax-strategy" style="margin-top: 15px;">
      <div foundation class="reports">
        <div class="reports tabs-content" data-tabs-content="report-tabs">
          <div class="reports tabs-panel is-active">
            <div class="row user-profile-css">
              <div class="column medium-12">
                <app-client-plans [clientId]="clientUserId" [clientData]="client" [estimateAccess]="estimatesAccess" [currentSubscription]="currentPlan" [userReadOnly]="userReadOnly" (onUpdationOfClient)="refreshClient()"></app-client-plans>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- ClickUp 868jtq1h0: TABBED layout deleted. Tax Projections lives on
       the new platform reached via /choose-platform; the legacy Tax
       Projections tab was a vestige of the first iteration. -->

</div>

<div *ngIf="reveal['editClient']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['editClient']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 50%;" [ngClass]="{'tpiq-reveal': reveal['editClient']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Update Client</span>
      <span class="float-right pointer" (click)="hideReveal('editClient')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body" style="padding: 15px;">
      <app-create-or-update-client [editMode]="true" [clientId]="clientUserId" (onCancelCreateOrUpdateOfClient)="hideReveal('editClient')"
                                 (onCreationOrUpdateOfClient)="refreshClient()"></app-create-or-update-client>
    </div>
  </div>
</div>
